import { Injectable } from '@angular/core';
import { Constant } from '../shared/shared/constants';
import { UserDetail } from '../shared/shared/user.service';
import { USERROLE } from '../shared/shared/models';
import { APP_MODULES, AppModuleNavItem } from './module-registry';

// Resolves which modules/utilities a user may access, using role and config-driven user lists.
@Injectable({ providedIn: 'root' })
export class ModuleAccessService {
  getAccessibleModules(user: UserDetail | undefined): AppModuleNavItem[] {
    if (!user) {
      return [];
    }
    return APP_MODULES.filter(module => this.canAccess(module, user));
  }

  canAccess(module: Partial<AppModuleNavItem>, user: UserDetail | undefined): boolean {
    if (!user || user.role === USERROLE.FA) {
      return false;
    }
    const roleOk = !module.allowedRoles?.length || module.allowedRoles.includes(user.role);
    const usersOk = !module.configUsersKey || this.isUserAllowed(module.configUsersKey, user);
    return roleOk && usersOk;
  }

  private isUserAllowed(configUsersKey: string, user: UserDetail): boolean {
    const allowed = (Constant.config[configUsersKey] as string[] | undefined) ?? [];
    if (!allowed.length) {
      return false;
    }
    return allowed.includes((user.userid || '').toLocaleUpperCase());
  }
}
